import { customerNameSchema as e } from "../customers/core.js";
import * as t from "zod";
// src/incidents/incident-customer.schema.ts
var n = t.strictObject({
	version: t.number().int().positive(),
	customerId: t.uuid()
}), r = t.strictObject({
	q: t.string().trim().min(1).max(100).refine((e) => e.isWellFormed() && !e.includes("\0"), "Invalid search text."),
	limit: t.coerce.number().int().min(1).max(50).default(50),
	cursor: t.string().min(1).max(4096).optional()
}), i = t.strictObject({
	id: t.uuid(),
	name: e
}), a = t.strictObject({
	items: t.array(i).max(50),
	nextCursor: t.string().max(4096).nullable()
});
export { n as incidentCustomerCommandSchema, i as incidentCustomerOptionSchema, a as incidentCustomerOptionsPageSchema, r as incidentCustomerOptionsQuerySchema };

//# sourceMappingURL=incident-customer.schema.js.map